class ProductMediaGallery extends HTMLElement {
  constructor() {
    super()
    this.gallery = this.querySelector("[data-gallery-main]")
    this.thumbs = this.querySelector("[data-gallery-thumbs]")
    this.id = this.dataset.sectionId

    let callback = (entries, observer) => {
      entries.forEach((entry) => {
        const ref = this.thumbs.querySelector(`[data-media-id="${entry.target.dataset.mediaId}"`)
        if (entry.isIntersecting) {
          ref.classList.add("border-cotton")
          this.thumbs.scrollTo({ top: 0, left: ref.offsetLeft, behavior: "smooth" })
        } else {
          ref.classList.remove("border-cotton")
        }
      })
    }
    let options = {
      root: null,
      rootMargin: "4000px 0px 4000px 0px",
      threshold: 0.6
    }
    this.thumbObserver = new IntersectionObserver(callback, options)

    this.init()
  }
  init() {
    this.thumbs.querySelectorAll("button").forEach((thumb) => {
      const mainGalleryItem = this.querySelector(`#${thumb.dataset.refId}`)
      thumb.addEventListener("click", () => {
        this.gallery.scrollTo({ top: 0, left: mainGalleryItem.offsetLeft, behavior: "smooth" })
      })
    })
    this.gallery.querySelectorAll("li").forEach((item) => {
      this.thumbObserver.observe(item)
    })
    this.setUpVariantListener()
  }
  setUpVariantListener() {
    const sectionId = document.querySelector('product-media-gallery').dataset.sectionId;
      document.addEventListener('DOMContentLoaded', function() {
        const variantSwitcher = document.querySelector(
          `variant-radios[data-section="${sectionId}"]`
        );
          variantSwitcher.addEventListener('change', function(event) {
              const newValue = event.target.value;
  
              if (newValue) {
                  const url = new URL(window.location.href);
                  url.searchParams.set('section_id', sectionId);
  
                  fetch(url)
                      .then(response => response.text())
                      .then(html => {
                          const parser = new DOMParser();
                          const doc = parser.parseFromString(html, 'text/html');
                          const newVariantTag = doc.querySelector('span#variant-tag');
                          const currentVariantTag = document.querySelector('span#variant-tag');
                          if (newVariantTag) {
                              currentVariantTag.innerHTML = newVariantTag.innerHTML;
                              currentVariantTag.classList.remove('hidden');
                          } else {
                            currentVariantTag.innerHTML = '';
                            currentVariantTag.classList.add('hidden');
                          }
                      })
                      .catch(error => console.error('Error fetching section:', error));
              }
          });
      });
  
      // This function listens for changes to the "data-option-for-variant-media" which defaults to the "color" option. When that option changes, product media whose alt text does not include the color value is hidden. The exception is any product media whose alt text includes the keyword "all"
      if (!this.dataset.showOnlyVariantMedia) {
          return
      }
      this.OPTION_FOR_IMAGES = this.getAttribute("data-option-for-variant-media")
          ? `option${this.getAttribute(`data-option-for-variant-media`)}`
          : "option1"
      this.option_value = this.getAttribute(`data-starting-${this.OPTION_FOR_IMAGES}`)?.toLowerCase()
      const variantSwitcher = document.querySelector(
          `variant-radios[data-section="${this.dataset.sectionId}"]`
      )
      const showHideMedia = (currentVariant) => {
          if(!currentVariant.featured_media) {
              return false;
          }
          this.querySelectorAll("[data-variant-alt]").forEach((media) => {
              let alt = media.dataset.variantAlt.toLowerCase()
              const [variantTitle, variantColor] = alt.split("|").map(str => str.trim());
              if (variantColor == this.option_value || alt.includes("| all")) {
                  media.classList.remove("hidden")
              } else if (currentVariant) {
                  let variant_media_id = media.dataset.mediaId
                  let current_featured = currentVariant.featured_media
                      ? `${this.dataset.sectionId}-${currentVariant.featured_media.id}`
                      : 0
                  if (current_featured == variant_media_id) {
                      media.classList.remove("hidden")
                  } else {
                      media.classList.add("hidden")
                  }
              } else {
                  media.classList.add("hidden")
              }
          })
      }
      if (this.option_value) {
          variantSwitcher.updateOptions()
          variantSwitcher.updateMasterId()
          showHideMedia(variantSwitcher.currentVariant)
      }
      variantSwitcher.addEventListener("change", () => {
          if (!variantSwitcher) {
              return
          }
          let newValue = variantSwitcher.currentVariant[this.OPTION_FOR_IMAGES].toLowerCase()
          if (newValue === this.option_value) {
              return
          }
          this.option_value = newValue
          showHideMedia(variantSwitcher.currentVariant)
      })
  }
}

customElements.define("product-media-gallery", ProductMediaGallery)
